import { Checkbox } from '@chakra-ui/react';
import { Avatar, ConfirmDialog } from '@halo/ui-chat-react';

export interface DeleteChatDialogProps {
  open: boolean;
  onClose: () => void;
  avatar: string;
  chatName: string;
  deleteChatHistory: boolean;
  setDeleteChatHistory: (deleteChatHistory: boolean) => void;
  onOk: () => Promise<void>;
  okLoading?: boolean;
}

export const DeleteChatDialog = ({
  open,
  onClose,
  avatar,
  chatName,
  deleteChatHistory,
  setDeleteChatHistory,
  onOk,
  okLoading,
}: DeleteChatDialogProps) => {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      icon={<Avatar src={avatar} size="lg" />}
      title={t('chatSettings.deleteChatTitle')}
      subTitle={t('chatSettings.deleteChatSubTitle', { name: chatName })}
      onOk={() => onOk()}
      okButtonProps={{
        loading: okLoading,
      }}
    >
      <Checkbox.Root
        size="sm"
        defaultChecked={deleteChatHistory}
        onCheckedChange={(e) => setDeleteChatHistory(!!e.checked)}
        cursor="pointer"
      >
        <Checkbox.HiddenInput />
        <Checkbox.Control cursor="pointer" borderRadius="sm" />
        <Checkbox.Label>{t('chatSettings.deleteChatHistoryDesc')}</Checkbox.Label>
      </Checkbox.Root>
    </ConfirmDialog>
  );
};
